import _ from 'lodash'
import vm from '../main'
import { API } from '../config'
import { httpClient as http } from '../services'

const internals = {}

internals.addTransportPoint = function(transport) {
    transport = (({
        cityId,
        transportName,
        transportLocation,
        geoloc,
        _id
        
    }) => {
        return {
            cityId,
            transportName,
        transportLocation,
        geoloc,
        _id
        }
    })(transport)

    return vm.$transportDataRepository
        .create(transport)
        .then(result => {
            transport = result.data
            return transport
        })
        .catch(error => {
            console.error('transportService.createRegion-error:\n', error)
            throw error
        })
}

internals.updateTransportPoint = function(transport) {
    transport = Object.assign({}, transport)
    transport = (({
        cityId,
        transportName,
        transportLocation,
        _id
        
        
    }) => {
        return {
            cityId,
            transportName,
        transportLocation,
        _id
        
            
        }
    })(transport)

    return vm.$transportDataRepository
        .update(transport._id, transport)
        .then(result => {
            transport = result.data
            return transport
        })
        .catch(error => {
            console.error('transportUpdate.update-error:\n', error)
            throw error
        })
}

internals.updateTransportPointStatus = function(id,status) {
    return http.put(API.TRANSPORT + '/' + id + '/status' + '/' + status)
}


internals.transportSearch = function(params,searchItem) {
    return http
      .get(`/datacity/search?page=${params.page}&limit=${params.limit}&searchString=${searchItem}`) 
      .then(result => {
        return result
      })
      .catch(error => {
        console.error('authService.inviteUser-error:\n', error)
        throw error
      })
  }

export default internals


// WEBPACK FOOTER //
// ./src/services/transport.service.js